import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { ShowMoreTooltip } from 'ziphy-web-shared/basic/lib/functional';
import { $calendar } from '../../Calendar.store';
import Card from '../Card';
import { usePreparedCardData } from '../Card.hooks';
import styles from './PracticeCard.module.scss';
const PracticeCard = ({ date, data }) => {
    const { t } = useTranslation();
    const cardData = usePreparedCardData({ date, data });
    const ids = typeof data.id === 'number' ? [data.id] : data.id.split('_').map(Number);
    const items = _.sortBy(ids).map((id) => $calendar.practices[id]);
    const names = items.map((item) => item === null || item === void 0 ? void 0 : item.name);
    // const maxVisibleNames = Math.max(1, Math.min(2, Math.floor(data.height / 2)))
    const visibleNames = names.slice(0, 1);
    const hasTooltip = visibleNames.length < names.length;
    return (_jsx(Card, { date: date, data: data, cardData: cardData, subTitle: _jsx(ShowMoreTooltip, { value: hasTooltip ? t('label.practices', { count: names.length }) : visibleNames, tooltipData: hasTooltip && names }), className: styles.wrapper }));
};
export default observer(PracticeCard);
